import React from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Dashboard from '../pages/admin/Dashboard';
import Produccion from '../pages/admin/Produccion';
import MenuMensual from '../pages/admin/MenuMensual';
import Platos from '../pages/admin/Platos';
import Categorias from '../pages/admin/Categorias';
import Pedidos from '../pages/admin/Pedidos';
import Usuarios from '../pages/admin/Usuarios';
import Sedes from '../pages/admin/Sedes';
import Sectores from '../pages/admin/Sectores';
import Informes from '../pages/admin/Informes';
import Configuracion from '../pages/admin/Configuracion';
import Logs from '../pages/admin/Logs';
import MiPedido from '../pages/empleado/Dashboard';
import Logo from '../components/Logo';
import PerfilUsuario from '../components/PerfilUsuario';
import '../styles/Admin.css';

function AdminLayout({ usuario, onLogout }) {
  const [showPerfil, setShowPerfil] = useState(false);

  return (
    <div className="app-container">
      <aside className="sidebar">
        <div style={{ 
          padding: '24px 20px', 
          borderBottom: '1px solid #FB8C00',
          background: 'linear-gradient(135deg, #27AE60 0%, #229954 100%)'
        }}>
          <Logo size="small" showText={true} textColor="white" style={{ 
            justifyContent: 'flex-start'
          }} />
          <p style={{ 
            fontSize: '14px', 
            color: 'rgba(255, 255, 255, 0.9)', 
            marginTop: '12px',
            fontWeight: 500
          }}>
            {usuario.nombreCompleto}
          </p>
          <p style={{ 
            fontSize: '12px', 
            color: 'rgba(255, 255, 255, 0.7)', 
            marginTop: '4px'
          }}>
            Administrador
          </p>
        </div>
        <nav>
          <Link to="/dashboard">📊 Dashboard</Link>
          <Link to="/produccion">👨‍🍳 Producción</Link>
          <Link to="/menu">📅 Menú Mensual</Link>
          <Link to="/platos">🍽️ Platos</Link>
          <Link to="/categorias">📋 Categorías</Link>
          <Link to="/pedidos">📦 Pedidos</Link>
          <Link to="/usuarios">👥 Usuarios</Link>
          {usuario.tipo_usuario === 'super_admin' && (
            <>
              <Link to="/sedes">🏢 Sedes</Link>
              <Link to="/sectores">🏗️ Sectores</Link>
            </>
          )}
          <Link to="/informes">📈 Informes</Link>
          {usuario.tipo_usuario === 'super_admin' && (
            <Link to="/configuracion">⚙️ Configuración</Link>
          )}
          <Link to="/logs">🔍 Monitoreo</Link>
          <div style={{ 
            borderTop: '1px solid rgba(255, 255, 255, 0.1)', 
            marginTop: '12px', 
            paddingTop: '12px' 
          }}>
            <Link to="/mi-pedido">🍴 Mi Pedido</Link>
          </div>
        </nav>
        <div style={{ padding: '20px', marginTop: 'auto' }}>
          <button
            className="btn"
            onClick={() => setShowPerfil(true)}
            style={{ 
              width: '100%',
              padding: '12px',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              background: '#FB8C00',
              color: '#fff',
              border: 'none',
              marginBottom: '12px',
              cursor: 'pointer'
            }}
          >
            👤 Mi Perfil
          </button>
          <button
            className="btn btn-secondary"
            onClick={onLogout}
            style={{ 
              width: '100%',
              padding: '12px',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            🚪 Cerrar Sesión
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/produccion" element={<Produccion />} />
          <Route path="/menu" element={<MenuMensual />} />
          <Route path="/platos" element={<Platos />} />
          <Route path="/categorias" element={<Categorias />} />
          <Route path="/pedidos" element={<Pedidos />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/sedes" element={<Sedes />} />
          <Route path="/sectores" element={<Sectores />} />
          <Route path="/informes" element={<Informes />} />
          <Route path="/configuracion" element={<Configuracion usuario={usuario} />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/mi-pedido" element={<MiPedido usuario={usuario} onLogout={onLogout} />} />
        </Routes>
      </main>

      {showPerfil && (
        <PerfilUsuario
          usuario={usuario}
          onClose={() => setShowPerfil(false)}
        />
      )}
    </div>
  );
}

export default AdminLayout;
